import { api } from "@/client/api"

export default {
    restartApply() {
        return api.post(`/apply/restart`)
    },

    startApplyWithToken(token) {
        return api.post(`/apply/start/tokens/${encodeURIComponent(token)}`)
    },

    startApplyWithEntityKey(entityKey, request = undefined) {
        return api.post(`/apply/start/entity-keys/${encodeURIComponent(entityKey)}`, request)
    },

    startApplyWithDefaultEntityKey(request = undefined) {
        return api.post("/apply/start", request)
    },

    finishCompleted() {
        return api.post(`/apply/finish/completed`)
    },

    finishCanceled() {
        return api.post(`/apply/finish/canceled`)
    },

    finishPending() {
        return api.post(`/apply/finish/pending`)
    },

    finishTimeout() {
        return api.post(`/apply/finish/timeout`)
    },

    apply(providerKey, request) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/apply`, request)
    },

    addBankCard(providerKey, request) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/application/bank-card`, request)
    },

    addBankAccount(providerKey, request) {
        return api.post(`providers/${encodeURIComponent(providerKey)}/application/bank-account`, request)
    },

    confirmPaymentPlan(providerKey, request) {
        return api.post(
            `/providers/${encodeURIComponent(providerKey)}/payment/plans/${encodeURIComponent(
                request.providerPlanCode
            )}/confirm-selection`
        )
    },

    prequalify(providerKey, request) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/prequalify`, request)
    },

    prescreen(providerKey, request) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/prescreen`, request)
    },

    patch(providerKey, request, applyMode) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/patch/${applyMode}`, request)
    },

    acceptOffer(providerKey, request) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/acceptOffer`, request)
    },

    selectPaymentPlan(providerKey, request) {
        return api.post(
            `/providers/${encodeURIComponent(providerKey)}/payment/plans/${encodeURIComponent(
                request.providerPlanCode
            )}/select`,
            request
        )
    },

    getDocuments(providerKey, types) {
        let url = `/providers/${encodeURIComponent(providerKey)}/application/documents`
        if (types) {
            url += "?types=" + encodeURIComponent(types)
        }
        return api.get(url)
    },

    getPaymentPlans(providerKey, request) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/payment/plans`, request)
    },

    publishPaymentPlansPresented(providerKey) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/payment/plans/presented`)
    },

    sendAnswers(providerKey, request) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/answers`, request)
    },

    refreshStipulations(providerKey, request) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/application/stipulations/refresh`, request)
    },

    getStipulationStatus(providerKey, stipulationId) {
        return api.get(`/providers/${encodeURIComponent(providerKey)}/application/stipulations/${stipulationId}/status`)
    },

    startProvider(providerKey, applyMode) {
        let url = "/apply/start/providers/" + encodeURIComponent(providerKey)

        if (applyMode) {
            url += "?mode=" + encodeURIComponent(applyMode)
        }

        return api.post(url)
    },
    esignApplication(providerKey) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/application/esign`)
    },

    completeApplication(providerKey) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/application/complete`)
    },

    getApplicationStatus(providerKey) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/application-status`)
    },

    getIframeUrl(providerKey, redirectUrl) {
        if (redirectUrl) {
            return api.get(
                `/providers/${encodeURIComponent(providerKey)}/iframeUrl?redirectUrl=${encodeURIComponent(redirectUrl)}`
            )
        } else {
            return api.get(`/providers/${encodeURIComponent(providerKey)}/iframeUrl`)
        }
    },

    publishContinueUrl(providerKey, url) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/continue-url/publish`, { url })
    },

    sdkConfig(providerKey) {
        return api.get(`/providers/${encodeURIComponent(providerKey)}/sdkConfig`)
    },

    updatePaymentMethod(providerKey, request) {
        return api.post(`/providers/${encodeURIComponent(providerKey)}/paymentMethod`, request)
    },
}
